// General context state statuses
export const CONTEXT_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Cocktail List Actions
export const CTLIST_ACTIONS = {
  UPDATE_LIST: 'updatelist',
  LOADING: 'loading',
  CLEAR_LIST: 'clearlist',
  ERROR: 'error',
};

// Selected Cocktail Actions
export const SELCOCKTAIL_ACTIONS = {
  UPDATE: 'update',
  LOADING: 'loading',
  CLEAR: 'clear',
  ERROR: 'error',
};

// Fitler Actions
export const FILTER_ACTIONS = {
  LOADING: 'loading',
  SET_ALLFILTERS: 'setallfilters',
  UPDATE_FILTERS: 'updatefilters',
  CLEAR_SELECTED: 'clearselected',
  ERROR: 'error',
};
